import {
  loadFromStorage,
  saveToStorage
} from 'app/assets/javascripts/utils/localstorage';
import { getDateNow } from 'app/assets/javascripts/utils/date';

const LOCAL_STORAGE_KEY = 'contentGateV2';
// Only count documents seen in the last 30 days. The value is in milliseconds
const PERIOD_TO_LOOK_BACK = 30 * 24 * 60 * 60 * 1000;

const hasValidId = (id) => !!id && typeof id === 'string';
const hasValidDate = (dateTime) => !!dateTime && getIsValidIsoDate(dateTime);

export const trackView = (id) => {
  let state = loadFromStorage(LOCAL_STORAGE_KEY);
  if (!Array.isArray(state.documents)) {
    state.documents = [];
  }

  const expiredTimestamp = new Date(
    getDateNow().getTime() - PERIOD_TO_LOOK_BACK
  ).toISOString();

  state.documents = state.documents
  .filter(isValidEntry)
  .filter((d) => d.at > expiredTimestamp)
  .filter((d) => `${d.id}` != `${id}`);

  state.documents.push({ id: id, at: getDateNow() });
  saveToStorage(LOCAL_STORAGE_KEY, state);
  return state.documents.length;
};

export const getIsValidIsoDate = (dateStr) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(dateStr)) {
    return false;
  } else {
    return new Date(dateStr).toISOString() === dateStr;
  }
};

function isValidEntry(entry) {
  return hasValidId(entry.id) && hasValidDate(entry.at);
}
